module.exports = __webpack_public_path__ + "img/icons BFr_34.cb917b57.svg";